import { combineReducers } from "redux";
import permission from "../features/admin/master/permission/Slice";
import country from "../features/admin/master/country/Slice";
import state from "../features/admin/master/state/Slice";
import city from "../features/admin/master/city/Slice";
import pincode from "../features/admin/master/pincode/Slice";
import vehicle_category from "../features/admin/master/vehiclecategory/Slice";
import banner from "../features/admin/master/banner/Slice";
import aboutus from "../features/admin/master/aboutus/Slice";
import keyfeature from "../features/admin/master/keyfeature/Slice";
import whychooseus from "../features/admin/master/whychooseus/Slice";
import termcondition from "../features/admin/master/termcondition/Slice";
import savelocation from "../features/admin/master/savelocation/Slice";
import goodtype from "../features/admin/master/goodtype/Slice";
import faq from "../features/admin/master/faq/Slice";
import privacypolicy from "../features/admin/master/privacypolicy/Slice";
import driverprivacypolicy from "../features/admin/master/driver_privacy_policy/Slice";
import trainingvideos from "../features/admin/master/trainingvideos/Slice";
import driver_banner from "../features/admin/master/driverbanner/Slice";
import model from "../features/admin/master/model/Slice";
import vehicle from "../features/admin/master/vehicle/Slice";
import ecofriendly from "../features/admin/master/ecofriendly/Slice";
import coupon from "../features/admin/master/coupon/Slice";
import coupon_history from "../features/admin/master/coupon_history/Slice";
import customer_booking_tnc from "../features/admin/master/customer_booking_tnc/Slice";
import customer_terms_and_condition from "../features/admin/master/customer_terms_and_condition/Slice";
import shipping_ride_policy from "../features/admin/master/shipping_ride_policy/Slice";
import cancellation_policy from "../features/admin/master/cancellation_policy/Slice";
import driver_terms_and_condition from "../features/admin/master/driver_terms_and_condition/Slice";
import booking_cancel_reason from "../features/admin/master/booking_cancel_reason/Slice";
import refund_policy from "../features/admin/master/refund_policy/Slice";
import amenity from "../features/admin/master/amenity/Slice";
import aboutme from "../features/admin/master/aboutme/Slice";
import vehicletype from "../features/admin/master/vehicletype/Slice";

const masters = combineReducers({
  permission: permission,
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  model: model,
  vehicle_category: vehicle_category,
  banner: banner,
  aboutus: aboutus,
  keyfeature: keyfeature,
  whychooseus: whychooseus,
  termcondition: termcondition,
  savelocation: savelocation,
  goodtype: goodtype,
  faq: faq,
  privacypolicy: privacypolicy,
  driverprivacypolicy: driverprivacypolicy,
  trainingvideos: trainingvideos,
  driver_banner: driver_banner,
  vehicle: vehicle,
  ecofriendly: ecofriendly,
  coupon: coupon,
  coupon_history: coupon_history,
  customer_booking_tnc: customer_booking_tnc,
  customer_terms_and_condition: customer_terms_and_condition,
  shipping_ride_policy: shipping_ride_policy,
  cancellation_policy: cancellation_policy,
  driver_terms_and_condition: driver_terms_and_condition,
  booking_cancel_reason: booking_cancel_reason,
  refund_policy: refund_policy,
  amenity: amenity,
  aboutme: aboutme,
  vehicletype: vehicletype,
});

export default masters;
